<template>
  <b-form-select 
    :id="selectId"
    v-model="propiedad" 
    :disabled="readOnly"
    :options="lista" 
    :state="valido"
    class="mb-3"
    @blur.native="validate">
    <template slot="first">
      <option :value="null" :disabled='nullDisabled'>Seleccione un {{ label }}</option>
    </template>
  </b-form-select>                 
</template>

<script>
export default {
  props: {
    selectId: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    nombre: {
      type: String,
      default: ''
    },
    readOnly: {
      type: Boolean,
      default: false    
    },
    valido: {
      type: Boolean,
      default: null    
    },
    lista: {
      type: Array,
      default: null
    },
    msjInvalido: {
      type: String,
      default: ''
    },
    labelCols: {
      type: Number,
      default: 1
    },
    nullDisabled: {
      type: Boolean,
      default: true
    },
    showLabel: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      propiedad: '',
      updating: false
    }
  },
  created() {
      this.updating = true;
      this.propiedad = this.nombre;
      this.updating = false;
  },
  computed: {
  },     
  methods: {
    validate() {
      this.$emit('validate');
    }
  },

  watch: {
    'nombre' : function(newVal, oldVal) {
      this.updating = true;
      this.propiedad = newVal;
      this.updating = false;
    },
    'propiedad' : function(newVal, oldVal) {
      if (newVal != oldVal && !this.updating) {
        this.$emit('updated', this.propiedad);
      }
    },
  }    
}
</script>

<style>
</style>
